import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { truncateText } from "@/lib/utils";
import Link from "next/link";
import { Icon } from "@/components/formatters/MXPIcon";
import { qualifyImageUrl } from "@/lib/formatters/formatImages";
interface FeaturedCardProps {
  image?: any;
  imageType?: "asImage" | "asBackground";
  eyebrow?: string;
  title?: string;
  description?: string;
  slug?: string;
  buttonLabel?: string;
  truncate?: boolean;
  truncateLength?: number;
}
const FeaturedCard = t0 => {
  const $ = _c(29);
  const {
    imageType: t1,
    image,
    eyebrow,
    title,
    description,
    slug,
    buttonLabel: t2,
    truncate,
    truncateLength
  } = t0;
  const imageType = t1 === undefined ? "asBackground" : t1;
  const buttonLabel = t2 === undefined ? "Read More" : t2;
  const imageUrl = image?.url || "";
  let t3;
  if ($[0] !== imageUrl) {
    const imageUrlStripped = imageUrl.split("?")[0];
    t3 = qualifyImageUrl(imageUrlStripped, 413, 390, "crop") || null;
    $[0] = imageUrl;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const imageUrlReset = t3;
  let t4;
  if ($[2] !== imageType || $[3] !== imageUrlReset) {
    t4 = imageType !== "asImage" && imageUrlReset && <div className="w-[413px] bg-cover bg-center text-transparent rounded-l-[10px] rounded-r-none object-cover" style={{
      backgroundImage: `url(${imageUrlReset})`
    }} />;
    $[2] = imageType;
    $[3] = imageUrlReset;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== imageType || $[6] !== imageUrlReset || $[7] !== title) {
    t5 = imageType == "asImage" && imageUrlReset && <Image className="md:max-w-[413px] rounded-tr-none rounded-br-none w-full" src={imageUrlReset} alt={title || ""} loading="lazy" width={413} height={390} />;
    $[5] = imageType;
    $[6] = imageUrlReset;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== eyebrow) {
    t6 = eyebrow && <div className="text-gray-m5 mb-1.5 uppercase text-lg font-bold leading-7 tracking-[1.44px] max-sm:text-sm max-sm:leading-[18px] max-sm:tracking-[0.7px]">{eyebrow}</div>;
    $[9] = eyebrow;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== title) {
    t7 = title && <h3 className="text-xl text-gray-m9 font-bold leading-7 mb-5">{title}</h3>;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== description || $[14] !== truncate || $[15] !== truncateLength) {
    t8 = description && truncate && <p className="text-gray-m9 text-base font-normal leading-6 tracking-normal mb-5">{truncateText(description, truncateLength)}</p>;
    $[13] = description;
    $[14] = truncate;
    $[15] = truncateLength;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== buttonLabel || $[18] !== slug) {
    t9 = slug && <Link href={slug} className="t2-terra-text-link no-underline text-base font-semibold leading-5 tracking-wide text-blue-trmb py-4 px-0 focus:underline active:underline">{buttonLabel}{" "}<Icon label="View Post" type="t2u-chevron-right" size={20} className="ml-5" /></Link>;
    $[17] = buttonLabel;
    $[18] = slug;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="p-8 lg:py-[45px] lg:px-[60px] flex-1 md:justify-center md:flex md:flex-col">{t6}{t7}{t8}{t9}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4 || $[27] !== t5) {
    t11 = <div className="shadow-[0_68px_21px_-56px_rgba(0,0,0,0.2)] hidden overflow-hidden bg-gray-m1 rounded-lg mb-5 xl:flex max-w-[413px] md:max-w-none">{t4}{t5}{t10}</div>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t5;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};
export default FeaturedCard;